import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

const getDefaultSelectedCabinClass = () => {
  return {
    bookingClassModels: [],
    additionalServices: [],
  };
};

export default {
  state: () => ({
    selectedCabinClass: getDefaultSelectedCabinClass(),
    cabinClasses: [],
  }),

  mutations: {
    setSelectedCabinClass(state, cabinClass) {
      Vue.set(state, "selectedCabinClass", cabinClass);
    },
    setCabinClasses(state, cabinClasses) {
      Vue.set(state, "cabinClasses", cabinClasses);
    },
    setDefaultSelectedCabinClass(state) {
      Vue.set(state, "selectedCabinClass", getDefaultSelectedCabinClass());
    },
    setDefaultCabinClassModule(state) {
      Vue.set(state, "selectedCabinClass", getDefaultSelectedCabinClass());
      Vue.set(state, "cabinClasses", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createCabinClass: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cabin-classes/entity", request, {})
        .then((response) => {
          context.commit("setSelectedCabinClass", response.data);
          return response.status;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadCabinClasses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/entity").then((response) => {
        return response.data;
      });
    },
    loadPublishedCabinClasses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/entity/published").then((response) => {
        return response.data;
      });
    },
    loadPublishedCabinClassesFromTmsCdn: (context) => {
      return axios.get(context.getters.getTmsCdnServiceUrl + "/cabin-classes.json").then((response) => {
        return response.data;
      });
    },
    loadCabinClass: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/entity/" + request.id).then((response) => {
        context.commit("setSelectedCabinClass", response.data);
      });
    },
    loadSelectedCabinClassHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteCabinClass: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/cabin-classes/entity/" + item.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          item.intents = intents;
          item.intentId = response.data.id;
          return item;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftCabinClass: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/cabin-classes/draft/" + item.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    recallCabinClass: (context, cabinClass) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/recall/" + cabinClass.intentId).then((response) => {
        helper.recallOrRejectEntity(cabinClass, "cabin_class");
        return response.data;
      });
    },

    cancelCabinClass: (context, cabinClass) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/cancel/" + cabinClass.intentId).then((response) => {
        return response.data;
      });
    },

    sendToApprovalCabinClass: (context, cabinClass) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/sendToApproval/" + cabinClass.intentId).then((response) => {
        if (cabinClass.intents[0].type === "CREATE_CABIN_CLASS") {
          cabinClass.intents[0].status = "WAITING_APPROVAL";
        } else if (cabinClass.intents[0].type === "UPDATE_CABIN_CLASS") {
          cabinClass.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    publishCabinClass: (context, cabinClass) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/publish/" + cabinClass.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectCabinClass: (context, cabinClass) => {
      return axios.get(context.getters.getMcServiceUrl + "/cabin-classes/reject/" + cabinClass.intentId).then((response) => {
        if (cabinClass.intents[0].type === "DELETE_CABIN_CLASS") {
          cabinClass.intents = null;
          cabinClass.intentId = 0;
        } else if (cabinClass.intents[0].type === "CREATE_CABIN_CLASS") {
          cabinClass.intents[0].status = "DRAFT";
        } else if (cabinClass.intents[0].type === "UPDATE_CABIN_CLASS") {
          cabinClass.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
  },
  getters: {
    getSelectedCabinClass: (state) => {
      return state.selectedCabinClass;
    },
    getCabinClasses: (state) => {
      return state.cabinClasses;
    },
  },
};
